// extracted by mini-css-extract-plugin
module.exports = {"root_div":"userDetails_root_div__3in3n","filter_btn":"userDetails_filter_btn__1LeYV","filter_btn_group":"userDetails_filter_btn_group__1M-T6"};